import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ROUTES } from '../../shared/routing/routes';
import { useOnboardingStore } from '../onboarding/hooks/useOnboardingStore';

type ReferralRedirectProps = {
  entryRoute?: string;
};

export const ReferralRedirect = ({ entryRoute }: ReferralRedirectProps) => {
  const navigate = useNavigate();
  const { referralCode } = useParams<{ referralCode: string }>();
  const setReferralCode = useOnboardingStore(state => state.setReferralCode);

  useEffect(() => {
    if (referralCode) {
      setReferralCode(referralCode);
    }
    navigate(entryRoute ?? ROUTES.onboarding.whatBringsYou, { replace: true });
  }, [referralCode, setReferralCode, navigate]);

  return null;
};
